import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations, getDataConfigurations } from './configurations';
import { apiAction as acceptInvitation } from './configurations/acceptInvitation';
import { apiAction as addAfsLicence } from './configurations/addAfsLicence';
import { apiAction as addIndustryRole } from './configurations/addIndustryRole';
import { apiAction as cancelSubscription } from './configurations/cancelSubscription';
import { apiAction as detachBusinessAdmin } from './configurations/detachBusinessAdmin';
import { apiAction as get } from './configurations/get';
import { apiAction as getCpdCategory } from './configurations/getCpdCategory';
import { apiAction as getCpdCategoryProgress } from './configurations/getCpdCategoryProgress';
import { apiAction as industryRoles } from './configurations/getIndustryRoles';
import { apiAction as subscription } from './configurations/getSubscription';
import { apiAction as getUserAfsLicences } from './configurations/getUserAfsLicences';
import { apiAction as invitationSignUp } from './configurations/invitationSignUp';
import { apiAction as leaveTeam } from './configurations/leaveTeam';
import { apiAction as removeAfsLicence } from './configurations/removeAfsl';
import { apiAction as setCpdCategorys } from './configurations/setCpdCategorys';
import { apiAction as signUp } from './configurations/signup';
import { apiAction as subscribePlan } from './configurations/subscribePlan';
import { apiAction as update } from './configurations/update';
import { apiAction as updateEmail } from './configurations/updateEmail';
import { apiAction as updateIndustryRole } from './configurations/updateIndustryRole';
import { apiAction as updatePassword } from './configurations/updatePassword';
import { apiAction as updatePaymentDetails } from './configurations/updatePaymentDetails';
import { apiAction as upgradeSubscription } from './configurations/upgradeSubscription';

export const apiActions = {
  user: {
    // User management.
    get,
    update,
    signUp,
    invitationSignUp,
    updateEmail,
    updatePassword,
    updatePaymentDetails,
    detachBusinessAdmin,

    // Industry resources.
    industryRoles,
    addIndustryRole,
    updateIndustryRole,

    // Areas of advice resources.
    getCpdCategory,
    getCpdCategoryProgress,
    setCpdCategorys,

    // AFSL resources.
    addAfsLicence,
    getUserAfsLicences,
    removeAfsLicence,

    // Invitations.
    acceptInvitation,

    // User subscriptions.
    subscribePlan,
    subscription,
    cancelSubscription,
    upgradeSubscription,

    leaveTeam
  }
};

const actions = {
  user: {
    ...mapActionsFromConfigurations('user')(configurations).user,
    ...mapActionsFromConfigurations('getData')(getDataConfigurations)

  }
}

export * from './configurations/endpoints';

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/user/actions.js